/**
 * Notificaciones admin (jaime@coolliving.io) vía POST /api/out/notify.
 * action: copy-promo-code | affiliate-redirect
 */
export function postOutboundAffiliateNotify({
  url = '',
  provider,
  colivingId = '',
  colivingTitle = '',
  userId = '',
  city = '',
  source = 'coliving-search',
  action,
  promoCode = '',
  referrerEmail = '',
  priceFrom = '',
}) {
  if (!provider) return;

  const params = new URLSearchParams({
    url: url || '',
    provider,
    colivingId,
    colivingTitle,
    userId: userId || '',
    city: city || '',
    source: source || 'coliving-search',
  });

  if (action) params.set('action', action);
  if (promoCode) params.set('promoCode', promoCode);
  const email = String(referrerEmail || '').trim().toLowerCase();
  if (email) params.set('referrerEmail', email);
  if (priceFrom != null && priceFrom !== '') {
    params.set('priceFrom', String(priceFrom));
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function -- fire-and-forget
  fetch(`/api/out/notify?${params.toString()}`, { method: 'POST', keepalive: true }).catch(() => {});
}
